import * as s from "./website-content.scss";
import {Resources} from "../../../../../resources/Resources";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";
import {WebsiteBlackFlowComponent} from "../black/flow/WebsiteBlackFlowComponent";
import {WebsiteBlackPlatformHomeComponent} from "../black/platform/models/WebsiteBlackPlatformHomeComponent";

export class WebsiteContentHomeComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.beginFree"),
                            title: Resources.t("words.mostPerformantContent"),
                            description: Resources.t("words.sedestralSystemDescription"),
                            people: true,
                            center: true
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            title: Resources.t("words.features"),
                            icon: "seo",
                            contents: [
                                {
                                    name: Resources.t("words.shopifyAudit"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bc.mp4"),
                                    duration: 20000
                                },
                                {
                                    name: Resources.t("words.shopifyOptimization"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bb.mp4"),
                                    duration: 25000
                                },
                                {
                                    name: Resources.t("words.shopifyResearch"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bd.mp4"),
                                    duration: 31000
                                },
                                {
                                    name: Resources.t("words.shopifyAnalysis"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-be.mp4"),
                                    duration: 21000
                                },
                                {
                                    name: Resources.t("words.shopifyCreation"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-bf.mp4"),
                                    duration: 22000
                                }
                            ]
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.dailyOptimizationUsers"),
                            size: "sizeMid",
                            shadow: "colorBlue"
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowComponent({
                                title: Resources.t("words.createAndOptimize"),
                                bigTitle: Resources.t("words.createEngagingContent"),
                                image: NetworkVendor.image("blog-c.webp"),
                                texts: {
                                    canCollapse: false,
                                    entries: [
                                        {
                                            title: Resources.t("words.auditYourSite"),
                                            description: Resources.t("words.auditDescription"),
                                            icon: "fire",
                                            iconColor: "colorPurple"
                                        },
                                        {
                                            title: Resources.t("words.autoOptimizeExistingContent"),
                                            description: Resources.t("words.autoOptimizeDescription"),
                                            icon: "aiStars",
                                            iconColor: "colorPurple"
                                        },
                                        {
                                            title: Resources.t("words.createEngagingSeoContent"),
                                            description: Resources.t("words.createEngagingDescription"),
                                            icon: "aiWrite",
                                            iconColor: "colorPurple"
                                        }, {
                                            title: Resources.t("words.analyzePerformance"),
                                            description: Resources.t("words.performanceDescription"),
                                            icon: "chart",
                                            iconColor: "colorPurple"
                                        }
                                    ]
                                }
                            }))}
                        </div>
                    </div>
                </div>
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPlatformHomeComponent())}
                    </div>
                </div>
            </div>
        `;
    }
}
